import { LinearProgress } from '@material-ui/core';

import { PageLayoutMui as PageLayout } from '@spotify/confidence-core-react';

import { useResourcePageLayoutProps } from './useResourcePageLayoutProps';

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- rendered inside already-tracked pages via ResourceGuard; tracking happens at the parent
export const ResourceLoadingPage = () => {
  const pageLayoutProps = useResourcePageLayoutProps({ isLoading: true });

  return (
    <PageLayout {...pageLayoutProps}>
      <LinearProgress />
    </PageLayout>
  );
};
